<template>
  <custom-dialog
    dialog-title="Deseja selecionar essa data?"
    :is-dialog-open="isDialogOpen"
    :close-dialog="closeDialog"
    max-width="600"
  >
    <v-form
      class="multi-col-validation"
      @submit.prevent="selecionarEvento"
    >
      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-center"
        >
          <v-btn
            outlined
            color="secondary"
            class="mr-4"
            @click="closeDialog"
          >
            Cancelar
          </v-btn>

          <v-btn
            type="submit"
            color="primary"
          >
            Selecionar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/dialog/Dialog.vue'
import useDialog from '@/composables/useDialog'

export default {
  components: {
    CustomDialog,
  },

  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    selecionarEvento: {
      type: Function,
      required: true,
    },
  },

  setup(_, { emit }) {
    const { closeDialog } = useDialog(emit, 'is-dialog-open')

    return {
      closeDialog,
    }
  },
}
</script>
